export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            关于天堂影视
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[700px] mx-auto">
            天堂影视创立于 2019 年，是国内领先的免费高清在线电影平台。我们秉持"让好电影触手可及"的初心，
            致力于为广大影迷提供免广告、不卡顿、高清蓝光的纯净观影体验。目前平台收录超过 10 万部电影资源，
            涵盖院线大片、高分经典、小众文艺、热门剧集等多种类型，每日更新 50 部以上新片。
            我们的技术团队持续优化播放引擎和 CDN 分发网络，确保每位观众无论身在何处都能享受影院级的流畅画质。
            天堂影视不设会员门槛、无需注册登录，打开即看，让电影回归纯粹的快乐。
          </p>
        </div>
      </div>
    </section>
  );
}